import { ComponentProps } from 'react';

import { Button } from '~/modules/elements/akui/button';
import { Icon } from '~/modules/elements/akui/icon';
import { Tooltip } from '~/modules/elements/tooltip';
import '~/modules/remote-mic/event-listeners';
import '~/modules/stats/index';
import useFullscreenToggle from '~/modules/toolbar/use-fullscreen-toggle';

interface Props {
  /** Callers set this to match whatever icon size their surrounding toolbar uses. */
  size?: ComponentProps<typeof Button>['size'];
}

function FullscreenButton({ size = 'large' }: Props) {
  const { isFullScreen, toggle } = useFullscreenToggle();

  return (
    <Tooltip title="Toggle fullscreen" place="bottom-end">
      <Button
        size={size}
        type="button"
        data-test="toggle-fullscreen"
        aria-label="Toggle fullscreen"
        onClick={toggle}
        leftIcon={<Icon icon={isFullScreen ? 'ic:baseline-fullscreen-exit' : 'ic:baseline-fullscreen'} />}
      />
    </Tooltip>
  );
}
export default FullscreenButton;
